// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conn-form-description {
  max-width: 800px;
  padding: 15px;
  border-radius: 5px;
  border: 2px solid var(--g-color-base-brand);
}`, "",{"version":3,"sources":["webpack://./src/ui/units/connections/components/ConnectorForm/components/Description/Description.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,2CAAA;AACJ","sourcesContent":[".conn-form-description {\n  max-width: 800px;\n  padding: 15px;\n  border-radius: 5px;\n  border: 2px solid var(--g-color-base-brand);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
